import * as React from "react";
import * as moment from "moment";
import { getBackOfficeEntityDataSource } from "@@modules/admin/api";
import type { IAppCommandPromptProvider, IAppCommandPromptResultGroup, IAppCommandPromptResultItem } from "./appcommandprompt";
import { CommunityItem } from "@@modules/common/communityitem";
import type { IAppCommandResultItemProps } from "./appcommandprompt.results";
import { EventItem } from "@@modules/common/eventitem";

// eslint-disable-next-line max-len
export const guidRegex = /^(?:\{{0,1}(?:[0-9a-fA-F]){8}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){12}\}{0,1})$/;

export class EventAndCommunitySearch implements IAppCommandPromptProvider {
    //trigger = inwinkSearchCommand;
    name = "eventandcommunitysearch";

    search(search: string): Promise<IAppCommandPromptResultGroup[]> {
        const results: IAppCommandPromptResultGroup[] = [];

        return Promise.all([
            this.searchEvent(search).then((res) => {
                if (res) {
                    results.push(res);
                }
            }),
            this.searchCommunity(search).then((res) => {
                if (res) {
                    results.push(res);
                }
            })
        ]).then(() => {
            return results;
        });
    }

    searchEvent(search: string): Promise<IAppCommandPromptResultGroup> {
        const routingEventDatasource = getBackOfficeEntityDataSource('', 'RoutingEvent', '');
        const fakeMyEventDatasource = getBackOfficeEntityDataSource('', 'me/events', '');
        routingEventDatasource.query = fakeMyEventDatasource.query;
        routingEventDatasource.count = fakeMyEventDatasource.count;
        let filters: any = {
            title: { $contains: search }
        };
        if (guidRegex.test(search)) {
            filters = {
                id: search
            };
        }

        const pageSize = 10;

        return routingEventDatasource.query({
            selects: {
                $all: true,
                stat: {
                    $all: true
                },
                // authTenant: {
                //     name: true
                // }
            },
            filters: filters,
            order: [{ by: 'startDate', desc: true }],
            page: {
                index: 0,
                size: pageSize
            }
        }).then((res) => {
            if (res && res.data) {
                const renderEventItem = (props: IAppCommandResultItemProps) => {
                    return <EventItem
                        className="focusable"
                        popovermgr={props.popovermgr}
                        popoverClassName="quicksearchpopover"
                        eventitem={props.item.rawdata}
                        customerid={props.item.rawdata.customerId}
                        onAfterClick={props.itemClicked}
                    />;
                };
                return {
                    label: "quicksearch.event",
                    hasMore: res.data.length == pageSize,
                    items: res.data.map((ev: any) => {
                        let eventLabel = ev.title;
                        if (ev.startDate && ev.endDate) {
                            eventLabel = eventLabel
                                + ` (${moment(ev.startDate).format("LL")} - ${moment(ev.endDate).format("LL")})`;
                        } else if (ev.startDate) {
                            eventLabel = eventLabel + ` (${moment(ev.startDate).format("LL")})`;
                        }

                        const item: IAppCommandPromptResultItem = {
                            id: ev.id,
                            label: eventLabel,
                            component: renderEventItem,
                            rawdata: ev,
                            link: `/${ev.customerId}/e/${ev.id}`
                        };
                        return item;
                    })
                };
            }
        }, (err) => {
            console.error("error searching events", err);
            return null;
        });
    }


    searchCommunity(search: string): Promise<IAppCommandPromptResultGroup> {
        const routingCommunityDatasource = getBackOfficeEntityDataSource('', 'RoutingCommunity', '');
        const fakeMyCommunityDatasource = getBackOfficeEntityDataSource('', 'me/communities', '');
        routingCommunityDatasource.query = fakeMyCommunityDatasource.query;
        routingCommunityDatasource.count = fakeMyCommunityDatasource.count;

        let filters: any = {
            name: { $contains: search }
        };
        if (guidRegex.test(search)) {
            filters = {
                id: search
            };
        }

        const pageSize = 10;

        return routingCommunityDatasource.query({
            selects: {
                $all: true,
                // authTenant: {
                //     name: true
                // }
            },
            filters: filters,
            order: [{ by: "name", desc: true }],
            page: {
                index: 0,
                size: pageSize
            }
        }).then((res) => {
            if (res && res.data) {
                const renderCommunityItem = (props: IAppCommandResultItemProps) => {
                    return <CommunityItem
                        key={props.item.id}
                        className="focusable"
                        popoverClassName="quicksearchpopover"
                        popovermgr={props.popovermgr}
                        communityitem={props.item.rawdata}
                        customerid={props.item.rawdata.customerId}
                        onAfterClick={props.itemClicked}
                    />;
                };

                return {
                    hasMore: res.data.length == pageSize,
                    label: "quicksearch.community",
                    items: res.data.map((customer: any) => {
                        const item: IAppCommandPromptResultItem = {
                            id: customer.id,
                            label: customer.name,
                            component: renderCommunityItem,
                            rawdata: customer,
                            link: `/${customer.customerId}/c/${customer.id}`
                        };
                        return item;
                    })
                };
            }
        }, (err) => {
            console.error("error searching communities", err);
            return null;
        });
    }
}